let tempScoreArr = [];

let counter = 17;

export const bestBallAndAggregateCal = (
    array,
    setTeamScoreSystem,
    setPlayersInOutScore,
    setOpen,
    setWinnerTeam,
    parIndexVal,
    handiCapDiff
) => {
    // 2 Point Match Scenerio
    let tempGroupArr = [...array.group1, ...array.group2];

    let [t1, t2, t3, t4] = tempGroupArr;

    tempScoreArr = [];
    counter = 17;

    for (let i = 0; i <= counter; i++) {
        if (
            t1[i].score > 0 &&
            t2[i].score > 0 &&
            t3[i].score > 0 &&
            t4[i].score > 0
        ) {
            let tempBpArr = [t1[i], t2[i], t3[i], t4[i]];

            calculateScore(
                tempBpArr,
                i,
                setTeamScoreSystem,
                array,
                setPlayersInOutScore,
                setOpen,
                setWinnerTeam,
                parIndexVal,
                handiCapDiff
            );
        }
    }
};

const calculateScore = (
    bpArr,
    index,
    setTeamScoreSystem,
    array,
    setPlayersInOutScore,
    setOpen,
    setWinnerTeam,
    parIndexVal,
    handiCapDiff
) => {
    let tempBpArr = [...bpArr];

    // Check advantage point
    for (let i = 0; i < bpArr.length; i++) {
        if (bpArr[i].advantage) {
            let score = bpArr[i].score - 1;
            tempBpArr[i] = {...tempBpArr[i], score: score};
        }
    }

    let team1Lowest = tempBpArr[0];
    let team2Lowest = tempBpArr[2];
    let team1Aggregate = 0;
    let team2Aggregate = 0;

    // Both Teams Best Game Cal
    for (let i = 0; i < tempBpArr.length; i++) {
        if (i < 2) {
            if (tempBpArr[i].score < team1Lowest.score) {
                team1Lowest = tempBpArr[i];
            }
        } else {
            if (tempBpArr[i].score < team2Lowest.score) {
                team2Lowest = tempBpArr[i];
            }
        }
    }

    // Both Teams Aggregate Cal
    for (let i = 0; i < tempBpArr.length; i++) {
        if (i < 2) {
            team1Aggregate += tempBpArr[i].score;
        } else {
            team2Aggregate += tempBpArr[i].score;
        }
    }

    let statusAggregate;
    let statusBestGame;

    let holePoints = 0;
    let label;

    // Best Game check
    if (team1Lowest.score === team2Lowest.score) {
        statusBestGame = "tie";
        holePoints = 0;
    } else if (team1Lowest.score < team2Lowest.score) {
        statusBestGame = "group1";
        holePoints = 1;
    } else {
        statusBestGame = "group2";
        holePoints = 1;
    }

    // Aggregate Check

    if (team1Aggregate === team2Aggregate) {
        statusAggregate = "tie";
    } else if (team1Aggregate < team2Aggregate) {
        statusAggregate = "group1";

        if (statusBestGame === "tie") {
            holePoints = 1;
        } else if (statusBestGame === "group1") {
            holePoints = 2;
        } else {
            holePoints = 0;
        }
    } else {
        statusAggregate = "group2";
        if (statusBestGame === "tie") {
            holePoints = 1;
        } else if (statusBestGame === "group2") {
            holePoints = 2;
        } else {
            holePoints = 0;
        }
    }

    if (statusAggregate === "tie" && statusBestGame === "tie") {
        label = "tie";
    } else if (statusAggregate === statusBestGame) {
        label = statusAggregate;
    } else {
        if (statusAggregate === "group1" || statusBestGame === "group1") {
            label = "group1";
        } else {
            label = "group2";
        }
    }

    // Assigning Score Points Cal
    let tempObj = {};
    if (index === 0) {
        // If 1st Hole Tie
        if (label === "tie") {
            tempObj = {
                id: index + 1,
                count: 0,
                label: "tie",
            };
        } else {
            tempObj = {
                id: index + 1,
                count: holePoints,
                label: label,
            };
        }
    } else {
        // Checking from 2nd Hole
        if (label === "tie") {
            tempObj = tempScoreArr[index - 1];
        } else if (label === tempScoreArr[index - 1].label) {
            // if previous and current whole winner same
            let score = tempScoreArr[index - 1].count + holePoints;
            tempObj = {
                id: index + 1,
                count: score,
                label: label,
            };
        } else {
            // If hole winner change
            if (tempScoreArr[index - 1].count === 1 && holePoints === 2) {
                tempObj = {
                    id: index + 1,
                    count: 1,
                    label: label,
                };
            } else if (tempScoreArr[index - 1].count === holePoints) {
                tempObj = {
                    id: index + 1,
                    count: 0,
                    label: "tie",
                };
            } else if (tempScoreArr[index - 1].count >= 2) {
                let score = tempScoreArr[index - 1].count - holePoints;
                tempObj = {
                    id: index + 1,
                    count: score,
                    label: tempScoreArr[index - 1].label,
                };
            } else {
                tempObj = {
                    id: index + 1,
                    count: holePoints,
                    label: label,
                };
            }
        }
    }

    tempScoreArr.push(tempObj);

    if (index >= 9) {
        if (tempScoreArr[index].count > (17 - index) * 2) {
            // autoHoleFilling(
            //   index,
            //   array,
            //   setPlayersInOutScore,
            //   tempScoreArr,
            //   parIndexVal,
            //   handiCapDiff
            // );

            tempScoreArr[index] = {
                ...tempScoreArr[index],
                count: `${tempScoreArr[index].count}&${17 - index}`,
            };

            setWinnerTeam((pre) => {
                return {
                    ...pre,
                    sudden_death: false,
                    score_up_group: tempScoreArr[index].label,
                    won: tempScoreArr[index].label,
                    autoScoreHoles: `${tempScoreArr[index].count}`,
                    score_up: true,
                    score_up_value: `${tempScoreArr[index].count}UP`,
                };
            });

            counter = index;
        } else if (index === 17) {
            if (tempScoreArr[index].count === 0) {
                setOpen(true);
            }
        }
    } else {
        setTeamScoreSystem([]);
        setTeamScoreSystem(tempScoreArr);
    }
};
